import { render, staticRenderFns } from "./vipServer.vue?vue&type=template&id=329a1e32&scoped=true&"
import script from "./vipServer.vue?vue&type=script&lang=js&"
export * from "./vipServer.vue?vue&type=script&lang=js&"
import style0 from "./vipServer.vue?vue&type=style&index=0&id=329a1e32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329a1e32",
  null
  
)

export default component.exports